/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APISupplierContact } from './APISupplierContact';
import {
    APISupplierContactFromJSON,
    APISupplierContactFromJSONTyped,
    APISupplierContactToJSON,
} from './APISupplierContact';

/**
 * 
 * @export
 * @interface APISupplierSearchResult
 */
export interface APISupplierSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APISupplierSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APISupplierSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APISupplierSearchResult
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplierSearchResult
     */
    ustId?: string;
    /**
     * 
     * @type {Array<APISupplierContact>}
     * @memberof APISupplierSearchResult
     */
    contacts?: Array<APISupplierContact>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISupplierSearchResult
     */
    contactEmails?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISupplierSearchResult
     */
    contactNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISupplierSearchResult
     */
    contactPhones?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISupplierSearchResult
     */
    contactLanguages?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APISupplierSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APISupplierSearchResult interface.
 */
export function instanceOfAPISupplierSearchResult(value: object): value is APISupplierSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APISupplierSearchResultFromJSON(json: any): APISupplierSearchResult {
    return APISupplierSearchResultFromJSONTyped(json, false);
}

export function APISupplierSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISupplierSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'name': json['name'],
        'ustId': json['ust_id'] == null ? undefined : json['ust_id'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(APISupplierContactFromJSON)),
        'contactEmails': json['contact_emails'] == null ? undefined : json['contact_emails'],
        'contactNames': json['contact_names'] == null ? undefined : json['contact_names'],
        'contactPhones': json['contact_phones'] == null ? undefined : json['contact_phones'],
        'contactLanguages': json['contact_languages'] == null ? undefined : json['contact_languages'],
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APISupplierSearchResultToJSON(value?: APISupplierSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'name': value['name'],
        'ust_id': value['ustId'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(APISupplierContactToJSON)),
        'contact_emails': value['contactEmails'],
        'contact_names': value['contactNames'],
        'contact_phones': value['contactPhones'],
        'contact_languages': value['contactLanguages'],
        'root_account_id': value['rootAccountId'],
    };
}

